import { setupRpcServices } from './App';
import ready from './ready'

ready(() => {
  setupRpcServices()
})

window.document.write('Suggested.co authentication service.')